<template>
  <div style="min-height: 100vh;">
    <nuxt v-if="$device.isDesktop" />

    <snack-bar-errors v-if="$device.isDesktop"></snack-bar-errors>

    <redirect-to-app v-if="$device.isDesktop === false"></redirect-to-app>
  </div>
</template>

<script>
import SnackBarErrors from "~/components/molecules/SnackBarErrors";
import RedirectToApp from "~/components/RedirectToApp";

export default {
  components: {
    SnackBarErrors,
    RedirectToApp,
  },
}
</script>


<style>
html, body {
  background-color: #F5F7FF;
}
</style>

